/**
 * Dependency Injection Module: Programs
 * Mirrors Dashboard DI structure; wires repository to API service implementation.
 */

import { Container } from "inversify";
import type { IProgramsRepository } from "../domain/repository/IProgramsRepository";
import { ProgramsRepositoryImpl } from "../data/repository/ProgramsRepositoryImpl";
import { ProgramsApiService } from "../data/remote/service/ProgramsApiService";

const TYPES = {
  IProgramsRepository: Symbol.for("IProgramsRepository"),
};

const programsContainer = new Container();

programsContainer
  .bind<IProgramsRepository>(TYPES.IProgramsRepository)
  .to(ProgramsRepositoryImpl)
  .inSingletonScope();

programsContainer.bind(ProgramsApiService).toSelf().inSingletonScope();

export { programsContainer, TYPES };

